export default "__VITE_ASSET__DYJvSIlY__"